module.exports = __webpack_public_path__ + "static/img/7.e615cf8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/zh/7.png
// module id = iR6D
// module chunks = 0